module.exports = __webpack_public_path__ + "static/media/left-medial-flexion.001f4e09.png";